var parent = require('../es/is-iterable');
require('../modules/web.dom-collections.iterator');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/is-iterable.js
// module id = 592
// module chunks = 0 1